<template src="./CoreBPPolicyHeader.html">
</template>

<script>
  import * as spaApi from "@/spaApi.js"
  import locationComponent from "@/components/BP_PolicyPlanLocation"
  import { mask } from "vue-the-mask"
  import * as common from "@/common.js"

export default {
  name: "core-bp-policy-header",
  components: {
    'location-section': locationComponent
  },
  directives: {
    mask
  },
  props: {
    name: {
      type: String
    },
    integrationData: {
      type: Object
    },
    parentData: {
      type: Object
    },
    submit: {
      type: Function
    },
    toggleOpenInBus: {
      type: Function
    },
    bpUserLocation: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      carrierData: [],
      salesLeadData: [],
      serviceLeadData: [],
      commissionNameData: [],
      datePickerFormat: 'MM/dd/yyyy',
      datePickerFormatMonthOnly: 'MM/yyyy',
      datePickerMask: '##/##/20##',
      datePickerPattern:  '/(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[012])[/](19|20)\d\d/g'
    };
  },
  mounted() {
      this.init();
  },
  methods: {
    init() {
      // Default values
      if (this.integrationData.policy.billingCarrierType == 0) {
        var insurer = this.integrationData.policy.validValues.billingCarrierTypes.find(x => x.name == 'Insurer/TPA');
        if (insurer)
          this.integrationData.policy.billingCarrierType = insurer.id;
      }
      if (this.integrationData.policy.carrierId && this.integrationData.policy.carrierName)
        this.carrierData = common.buildDefaultOption(this.integrationData.policy.carrierId, this.integrationData.policy.carrierName);
      if (this.integrationData.policy.salesLeadId && this.integrationData.policy.salesLeadName)
        this.salesLeadData = common.buildDefaultOption(this.integrationData.policy.salesLeadId, this.integrationData.policy.salesLeadName);
      if (this.integrationData.policy.serviceLeadId && this.integrationData.policy.serviceLeadName)
        this.serviceLeadData = common.buildDefaultOption(this.integrationData.policy.serviceLeadId, this.integrationData.policy.serviceLeadName);
      if (this.integrationData.policy.billingCarrierId && this.integrationData.policy.billingCarrierName)
        this.commissionNameData = common.buildDefaultOption(this.integrationData.policy.billingCarrierId, this.integrationData.policy.billingCarrierName);

      if (this.integrationData.policy.regionId == 0)  // For validation of required fields - 0 is considered a value
        this.integrationData.policy.regionId = null;
      if (this.integrationData.policy.serviceLeadId == 0)
        this.integrationData.policy.serviceLeadId = null;
      if (this.integrationData.policy.salesLeadId == 0)
        this.integrationData.policy.salesLeadId = null;
      if (this.integrationData.policy.carrierId == 0)
        this.integrationData.policy.carrierId = null;
      if (this.integrationData.policy.newBusinessUntil)
        this.$refs.businessUntilValidator.validate(); // Need to manually validate for styling issue - field label will display in the field instead of above
    },
    toggleBus(toggleValue) {
      this.toggleOpenInBus(toggleValue);
    },
    onSubmit() {
      // Call submit from main form
      this.submit();
    },
    callForceCorrectDate(event, vmodel, property) {
      // Couldn't get inline calls to common.js to work. Don't have time at the moment to figure it out. This works, so moving on.
      common.forceCorrectDate(event, vmodel, property);
    },
    callSetInitialRenewalDate(event, vmodel, property) {
      // Couldn't get inline calls to common.js to work. Don't have time at the moment to figure it out. This works, so moving on.
      common.setInitialRenewalDate(event, vmodel, property);
    },
    onSearchCarrier(search, loading) {
      if (!search) { return; }
      loading(true);
      spaApi.getCarriers(loading, search, this.integrationData.policy.originationReason, this.integrationData.policy.carrierId, this.carrierDataGetSet);
    },
    carrierDataGetSet(apiData) {
      if (apiData)
        this.carrierData = apiData;
      else
        return this.carrierData;
    },
    onSearchSalesLead(search, loading) {
      if (!search) { return; }
      loading(true);
      spaApi.getBroker(loading, search, this.integrationData.policy.salesLeadId, this.salesLeadDataGetSet);
    },
    salesLeadDataGetSet(apiData) {
      if (apiData)
        this.salesLeadData = apiData;
      else
        return this.salesLeadData;
    },
    onSearchServiceLead(search, loading) {
      if (!search) { return; }
      loading(true);
      spaApi.getBroker(loading, search, this.integrationData.policy.serviceLeadId, this.serviceLeadDataGetSet);
    },
    serviceLeadDataGetSet(apiData) {
      if (apiData)
        this.serviceLeadData = apiData;
      else
        return this.serviceLeadData;
    },
    copyLocationFromAccount() {
      
      var policyCopy = JSON.parse(JSON.stringify(this.integrationData.policy));
      policyCopy.regionId = this.integrationData.account.regionId;
      policyCopy.regionName = this.integrationData.account.regionName;
      policyCopy.officeId = this.integrationData.account.officeId;
      policyCopy.officeName = this.integrationData.account.officeName;
      policyCopy.departmentId = this.integrationData.account.departmentId;
      policyCopy.departmentName = this.integrationData.account.departmentName;

      this.integrationData.policy = JSON.parse(JSON.stringify(policyCopy));
      this.$refs.locationRef.assignOnFly(this.integrationData)
    },
    copyTeamFromAccount() {
      let producer = this.parentData.primaryProducerData.find(x=> x.id == this.integrationData.account.producerName);
      if (producer) {
        this.salesLeadData = common.buildDefaultOption(producer.id, producer.name);
        this.integrationData.policy.salesLeadId = this.salesLeadData[0].id;
        this.integrationData.policy.salesLeadName = this.salesLeadData[0].name; //need this to rebuild array on init after close re-open popup
      }

      let primaryServiceLead = this.parentData.primaryServiceLeadData.find(x=> x.id == this.integrationData.account.primaryServiceLeadUserId);
      if (primaryServiceLead) {
        this.serviceLeadData = common.buildDefaultOption(primaryServiceLead.id, primaryServiceLead.name);
        this.integrationData.policy.serviceLeadId = this.serviceLeadData[0].id;
        this.integrationData.policy.serviceLeadName = this.serviceLeadData[0].name; //need this to rebuild array on init after close re-open popup
      }
    },
    onCommissionPaidByChange(billingCarrierType) {
      this.commissionNameData = [];
      this.integrationData.policy.billingCarrierId = null;
    },
    onCommissionPaidName(search, loading) {
      if (!search) { return; }
      loading(true);
      spaApi.getCommissionPaidNames(loading, search, this.integrationData.policy.billingCarrierType, this.integrationData.policy.originationReason, this.integrationData.policy.billingCarrierId, this.commissionNameDataGetSet);
    },
    commissionNameDataGetSet(apiData) {
      if (apiData) {
        this.commissionNameData = apiData;
      }
      else {
        return this.commissionNameData;
      }
    }, copyLocationFromAccountTooltip() {
      return this.$t("CopyLocation");
    }, copyTeamFromAccountTooltip() {
      return this.$t("CopyTeam");
    },
    onCarrierSelect(selection) {
      this.integrationData.policy.carrierName = selection === null ? null : this.carrierData.find(x => x.id == selection).name;
    },
    onSalesLeadSelect(selection) {
      this.integrationData.policy.salesLeadName = selection === null ? null : this.salesLeadData.find(x => x.id == selection).name;
    },
    onServiceLeadSelect(selection) {
      this.integrationData.policy.serviceLeadName = selection === null ? null : this.serviceLeadData.find(x => x.id == selection).name;
    },
    onCommissionsPaidBySelect(selection) {
      this.integrationData.policy.billingCarrierName = selection === null ? null : this.commissionNameData.find(x => x.id == selection).name;
    },
		policyGroupNumberToolTip() {
		  return this.$t("BPPolicyAllowedSpecialCharacters");
		}
  }
};
</script>
